import React from "react"
import Downloads from "../components/downloads"

export default function DownloadsSpanish() {
  return <Downloads language="es" />
}
